import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=2c750ff4"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c750ff4')) {
      api.createRecord('2c750ff4', component.options)
    } else {
      api.reload('2c750ff4', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=2c750ff4", function () {
      api.rerender('2c750ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/Question.vue"
export default component.exports